import { render, staticRenderFns } from "./menusSetting.vue?vue&type=template&id=6a264cf4&scoped=true"
import script from "./menusSetting.vue?vue&type=script&lang=js"
export * from "./menusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a264cf4",
  null
  
)

export default component.exports